import React from "react";

var MagicWandIcon = function MagicWandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23 16h-2v-2a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2zM19 4h1v1a1 1 0 1 0 2 0V4h1a1 1 0 1 0 0-2h-1V1a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2zM4 5h2v2a1 1 0 1 0 2 0V5h2a1 1 0 1 0 0-2H8V1a1 1 0 1 0-2 0v2H4a1 1 0 1 0 0 2zm13.121 1.879a2.998 2.998 0 0 0-4.242 0l-12 12A2.998 2.998 0 0 0 3 24a2.99 2.99 0 0 0 2.121-.879l12-12a2.998 2.998 0 0 0 0-4.242zm-1.414 2.828l-1 1a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l1-1a.999.999 0 1 1 1.414 1.414z"
  }));
};

MagicWandIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
MagicWandIcon.defaultProps.solid = true;
export default MagicWandIcon;